import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { TranslateModule } from '@ngx-translate/core';
import { MeetingType } from '@vendasta/meetings';

type DisplayMeetingType = MeetingType & { displayName: string };

@Component({
  selector: 'meeting-scheduler-meeting-filter',
  templateUrl: './meeting-filter.component.html',
  styleUrls: ['./meeting-filter.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, MatChipsModule, TranslateModule],
})
export class MeetingFilterComponent {
  @Input()
  selectedFilter = '';
  @Input() set meetingTypes(meetingsTypes: (MeetingType & { calendarName?: string })[]) {
    if (!meetingsTypes) {
      this.displayedMeetingTypes = [];
    } else {
      this.displayedMeetingTypes = meetingsTypes.map((mt) => {
        if (mt.calendarName) {
          return { ...mt, displayName: `${mt.calendarName}: ${mt.name}` };
        }
        return { ...mt, displayName: mt.name };
      });
    }
  }

  displayedMeetingTypes: DisplayMeetingType[];

  @Output() meetingTypeIdsSelected: EventEmitter<string[]> = new EventEmitter();

  onselectionchange(id: string): void {
    if (id === 'all') {
      this.meetingTypeIdsSelected.emit([]);
    } else {
      this.meetingTypeIdsSelected.emit([id]);
    }
  }
}
